
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SortSettingsDialog extends SiteEntityDialog<SortSettingsRow, any> {
        protected getFormKey() { return SortSettingsForm.formKey; }
        protected getIdProperty() { return SortSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return SortSettingsRow.localTextPrefix; }
        protected getNameProperty() { return SortSettingsRow.nameProperty; }
        protected getService() { return SortSettingsService.baseUrl; }

        protected form = new SortSettingsForm(this.idPrefix);

    }
}